import { FC, useCallback, useState } from "react";
import { FormikHelpers } from "formik";
import {
  Form,
  Button,
  Modal,
  MessageField,
  FormButtons,
  useFileParser,
  Checkbox,
} from "@epcnetwork/core-ui-kit";

import { FormField } from "components";
import { OverlapInsightFileItem, OverlapInsightValues } from "../overlap-insight.types";
import { validationSchema } from "../overlap-insight.constants";

import styles from "../overlap-insight.module.css";

type MatchingLeadsModalFormProps = {
  file: OverlapInsightFileItem;
  setClose: VoidFunction;
  onSubmitClick: (fileValues: OverlapInsightFileItem) => void;
  onSameSettingsUsage: (fileValues: OverlapInsightFileItem, close: () => void) => void;
};

export const OverlapInsightFormModal: FC<MatchingLeadsModalFormProps> = ({
  file,
  setClose,
  onSubmitClick,
  onSameSettingsUsage,
}) => {
  const { loading, parsedFile, error } = useFileParser(file.originalFile);

  const [sameSettings, setSameSettings] = useState(false);
  const [initialValues] = useState<OverlapInsightValues>({ headerValues: file.data });

  const onSubmit = (
    values: OverlapInsightValues,
    { setSubmitting }: FormikHelpers<OverlapInsightValues>,
  ) => {
    const fileValues = {
      ...file,
      isTuned: true,
      data: { ...file.data, ...values.headerValues },
    };

    if (!sameSettings) onSubmitClick(fileValues);
    if (sameSettings) onSameSettingsUsage(fileValues, setClose);

    setSubmitting(false);
  };

  const handleSameSettingsChange = useCallback((value: string, isChecked: boolean) => {
    setSameSettings(isChecked);
  }, []);

  return (
    <Modal isOpen={!!file} setClose={setClose}>
      <h2>Set values {file.originalFile.name}</h2>
      <MessageField message={error} />
      <Form
        initialValues={initialValues}
        enableReinitialize
        onSubmit={onSubmit}
        loading={loading}
        validationSchema={validationSchema}
      >
        <FormField
          type="file-table"
          name="headerValues"
          label="Select Email column"
          parsedFile={parsedFile}
          loading={loading}
          selector="radio"
        />

        <Checkbox
          checked={sameSettings}
          value="sameSettings"
          onChange={handleSameSettingsChange}
          label="Use same settings for each file in the pipeline"
          disabled={false}
          className={styles.checkbox}
          disableError
        />
        <FormButtons>
          <Button appearance="secondary" onClick={setClose}>
            Cancel
          </Button>
          <Button type="submit">Set values</Button>
        </FormButtons>
      </Form>
    </Modal>
  );
};
